/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import OneClickSubscribeButton from '../one_click_subscribe_button/one_click_subscribe_button';
import Spinner from '../spinner/spinner';
import { getNewsletter } from '../../../services/newsletter/newsletter.api.service';
import { hasPermission } from '../../../services/permissions/permissions.service';
/* eslint-enable max-len */

const OneClickSubscribeHOC = ({
  newsletter,
  checkIfSubscribed = true,
  hideIfSubscribed = true,
  showInfoOnSuccess = false,
}) => {
  const [newsletterToDisplay, setNewsletterToDisplay] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isEnabled, setIsEnabled] = useState(false);
  /*
   * Fetches the newsletter data, to know if user is subscribed or not, and show/hide accordingly
   */
  useEffect(() => {
    if (!checkIfSubscribed) {
      setIsLoading(false);
      return;
    }

    getNewsletter(newsletter.id)
      .then((data) => {
        setNewsletterToDisplay(data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!newsletterToDisplay.required_privilege) {
      setIsEnabled(true);
      return;
    }

    hasPermission(newsletterToDisplay?.required_privilege?.constant_name).then(setIsEnabled);
  }, [newsletterToDisplay?.required_privilege]);
  /*
   * When a newsletter comes as newsletter prop and 'checkIfSubscribed' is false, it sets it as
   * useState (newsletterToDisplay) because it is gonna be rendered
   */
  useEffect(() => {
    if (!checkIfSubscribed) {
      setNewsletterToDisplay(newsletter);
    }
  }, [newsletter]);

  if (newsletterToDisplay?.subscribed && hideIfSubscribed) return null;

  return isLoading ? (
    <Spinner isLoading={isLoading}></Spinner>
  ) : (
    <OneClickSubscribeButton
      newsletter={newsletterToDisplay}
      showInfoOnSuccess={showInfoOnSuccess}
      isEnabled={isEnabled}
    ></OneClickSubscribeButton>
  );
};

OneClickSubscribeHOC.propTypes = {
  newsletter: PropTypes.shape({
    id: PropTypes.number.isRequired,
    permalink: PropTypes.string,
    icon: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  checkIfSubscribed: PropTypes.bool,
  hideIfSubscribed: PropTypes.bool,
  showInfoOnSuccess: PropTypes.bool,
};

export default OneClickSubscribeHOC;
